import { USER, COMPANY_ADMIN, SYS_ADMIN } from 'config/permissions/roles';

export default class ProductsService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  setQuery(query) {
    this.query = query;
  }

  getProducts() {
    return this.$http.get('/api/product/search_all', {
      params: {
        ...this.query
      }
    });
  }

  getProductsBySpecies(species) {
    return this.$http.get('/api/product/search_by_species', {
      params: {
        ...this.query,
        selectedSpecies: species
      }
    });
  }

  getProductsByMember(memberId) {
    return this.$http.get('/api/product/search_by_member', {
      params: {
        ...this.query,
        memberId
      }
    });
  }

  getProductsByIngredient(ingredientId) {
    return this.$http.get('/api/product/search_by_ingredient', {
      params: {
        ...this.query,
        userIngredientId: ingredientId
      }
    });
  }

  getProductsBySystemIngredient(ingredientId) {
    return this.$http.get('/api/product/search_by_system_ingredient', {
      params: {
        ...this.query,
        systemIngredientId: ingredientId
      }
    });
  }

  getProductsMissingProductInfo() {
    return this.$http.get('/api/product/search_by_missing_product_info', {
      params: {
        ...this.query
      }
    });
  }

  getProductsMissingSalesData() {
    return this.$http.get('/api/product/search_by_missing_sale_data', {
      params: {
        ...this.query
      }
    });
  }

  getAlerts() {
    return this.$http.get('/api/alert/load_alert_product');
  }

  updateMissingUsages(usages) {
    return this.$http.post('/api/usage/update_missing_usage', {
      usages
    });
  }

  removeSignature(productId) {
    return this.$http.delete(`/api/product/${productId}/sign`);
  }

  setDiscontinuedStatus(productId, isDiscontinued) {
    return this.$http.put(`/api/product/${productId}/discontinue`, {
      productId,
      isDiscontinued
    });
  }

  getSearchTypes() {
    return [{
      name: 'All Products',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Ingredient Name',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Species',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${SYS_ADMIN}`]
    }, {
      name: 'Missing - Containers Shipped Data',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${SYS_ADMIN}`]
    }, {
      name: 'Missing - Product Information',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by System Ingredient Name',
      permission: `${SYS_ADMIN}`
    }, {
      name: 'Search by Member',
      permission: `${SYS_ADMIN}`
    }];
  }

  getLabelThumbnail(productId) {
    return this.$http.get(`/api/product_label/${productId}/thumbnail`);
  }

  getLabel(productId) {
    return this.$http.get(`/api/product_label/${productId}/request`);
  }

  getLabelImage(productId) {
    return this.$http.get(`/api/product_label/${productId}`);
  }
}



// WEBPACK FOOTER //
// ./components/app/products/products.service.js